import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Award } from 'lucide-react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-8 md:py-20 px-4 max-w-4xl mx-auto" data-id="element-176">
      <FadeIn data-id="element-177">
        <div className="bg-[#1f1b16] border border-[#7c3aed]/30 rounded-2xl md:rounded-[2.5rem] p-5 md:p-16 text-center relative overflow-hidden shadow-[0_20px_50px_rgba(31,27,22,0.15)]" data-id="element-178">
          {/* Subtle background pattern */}
          <div className="absolute inset-0 opacity-[0.05] bg-[radial-gradient(#7c3aed_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-179"></div>

          <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-transparent via-[#7c3aed] to-transparent" data-id="element-180"></div>

          <div className="relative z-10" data-id="element-181">
            <div className="inline-flex items-center justify-center w-20 h-20 md:w-28 md:h-28 rounded-full bg-[#7c3aed]/10 mb-4 md:mb-8 border-2 border-[#7c3aed]/20 relative" data-id="element-182">
              <div className="absolute inset-0 bg-[#7c3aed]/20 blur-2xl rounded-full animate-pulse" data-id="element-183"></div>
              <ShieldCheck className="w-10 h-10 md:w-14 md:h-14 text-[#7c3aed] relative z-10" data-id="element-184" />
              <div className="absolute -bottom-2 -right-2 bg-[#7c3aed] text-black rounded-full p-1.5 md:p-2 shadow-lg" data-id="element-185">
                <Award className="w-4 h-4 md:w-5 md:h-5" data-id="element-186" />
              </div>
            </div>

            <h2 className="text-2xl md:text-5xl font-black mb-4 md:mb-8 text-white tracking-tight" data-id="element-187">
              GARANTÍA 7 DÍAS <br className="md:hidden" data-id="element-188" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#7c3aed] to-[#a78bfa]" data-id="element-189">
                — SIN PREGUNTAS
              </span>
            </h2>

            <div className="space-y-3 md:space-y-6 text-base md:text-2xl text-[#e7dfce] font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-190">
              <p data-id="element-191">
                Abrís los tomos. Los aplicás 7 días. Si no es exactamente lo que
                esperabas:
              </p>
              <motion.div whileHover={{
              scale: 1.05
            }} className="bg-[#7c3aed]/10 border border-[#7c3aed]/30 rounded-2xl p-4 md:p-6 mt-4 md:mt-8 inline-block" data-id="element-192">
                <p className="text-[#7c3aed] font-black text-lg md:text-3xl" data-id="element-193">
                  → Devolución del 100%. <br className="md:hidden" data-id="element-194" />
                  Sin formularios. Sin drama.
                </p>
              </motion.div>
              <p className="text-xs md:text-sm text-[#6b6358] mt-5 md:mt-10 pt-4 md:pt-8 border-t border-[#7c3aed]/20 uppercase tracking-widest font-bold" data-id="element-195">
                Tasa de devolución: menos del 1%.
              </p>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}